import React from "react";
import { Container, Row } from "react-bootstrap";
import { AiFillGithub, AiFillLinkedin } from "react-icons/ai";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { MdOutlineEmail } from "react-icons/md";
AOS.init();
AOS.refreshHard();


function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (

    <Container fluid className="footer text-center">
      <Row >
        <div className="footer-body">
          <li className="social-icons">
            <a
              href="https://github.com/Ravi-047"
              style={{ color: "white" }}
              target="_blank"
              rel="noopener noreferrer"
              className="display-6"
            >
              <AiFillGithub />
            </a>
          </li>
          <li className="social-icons">
            <a
              href="https://www.linkedin.com/in/ravi-ranjan-136844231/"
              style={{ color: "white" }}
              target="_blank"
              rel="noopener noreferrer"
              className="display-6"
            >
              <AiFillLinkedin />
            </a>
          </li>
          <li className="social-icons">
            <a
              href="mailto:ravi047raj@gmail.com"
              style={{ color: "white" }}
              target="_blank"
              rel="noopener noreferrer"
              className="display-6"
            >
              <MdOutlineEmail />
            </a>
          </li>
        </div>
      </Row>

      <Row>
        <p className="mt-4 pt-2 h2">Copyright © {year} Ravi Ranjan</p>
      </Row>
    </Container>

  );
}

export default Footer;
